import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles/index";
import UserAvatar from "../../../user-avatar/UserAvatar";
import Hidden from '@material-ui/core/Hidden';
import {Providers} from "./Providers";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    }
}));

export const ProvidersBrowserSimple = ({
                                           action,
                                           ...properties
                                       }: any) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const row = (provider: any) => <TableRow key={provider.userId}>
        <TableCell component="th" scope="row" className={classes.avatarColumn}>
            <UserAvatar userId={provider.userId}/>
        </TableCell>
        <TableCell>
            <Typography variant="body1">{provider.firstName} {provider.lastName}</Typography>
            <Typography variant="body2"
                        color={'textPrimary'}>{provider.email}</Typography>
        </TableCell>
        {action &&
            <TableCell className={classes.actionColumn} align="center">
                {action(provider)}
            </TableCell>
        }
    </TableRow>;

    const header = <TableRow>
        <TableCell className={classes.avatarColumn}></TableCell>
        <TableCell>{t('ProGuest.Providers.Table.Headers.User')}</TableCell>
        {
            action && <TableCell className={classes.actionColumn}></TableCell>
        }
    </TableRow>;

    return <Providers
        {...properties}
        headerRender={() => header}
        rowRender={row}
    />;
};
